/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/**
 * 网络请求封装
 * 将各个的网络请求配置在对应的api文件中
 * 包装之后对外开放service，直接直接的方法，供调用
 */
import {config, request} from 'ice';
import {store} from '@ice/stark-data';
import LzMsg from '@/components/common/LzMessage';
import Qs from 'qs';
// 引入各个模块对应的接口的配置文件
import Apis from './apis';
import CrowdApis from './crowd.apis';
import commonApis from './common.apis';
import CanvasApis from './canvas.apis';
import AutoModelApis from './autoModel.apis';
import GoodsApis from './goods.apis';
import {isInIcestark} from '@ice/stark-app';

let allApis= {...Apis,...CrowdApis, ...CanvasApis, ...AutoModelApis, ...GoodsApis, ...commonApis}
/**
 * 判断是否登录
 * @param url-请求路径，如果是/auth/login，证明是登录接口，去获取token，这个请求需要直接resolve
 */
const checkTokenExist = (url) => new Promise((resolve) => {
  // let count = 0
  const interval = setInterval(() => {

    if (url.indexOf('/auth/login') > -1) {

      resolve('');
    } else {
      const token = sessionStorage.getItem('LZ_SSO_TOKEN');
      if (typeof token === 'string' && token !== '') {
        clearInterval(interval);
        resolve(token);
      }
    }
  }, 10)
})

console.log('config.baseURL', config.baseURL);

// 此处设置会被导出作为app.tsx中的request配置项
const requestConfig = {
  request: [
    {
      // 网络请求的地址
      baseURL: config.baseURL,
      interceptors: {
        request: {
          onConfig: (reqConfig) => {
            if (!isInIcestark()) {
              const token = sessionStorage.getItem('LZ_SSO_TOKEN');
              reqConfig.headers['Authorization'] = token;
              reqConfig.headers['prod'] = 'dy_cjyx';
              return reqConfig;
            } else {
              const token = sessionStorage.getItem('LZ_SSO_TOKEN');
              if (token && token !== '') {
                // token存在，请求头里加token
                reqConfig.headers['Authorization'] = token;
                reqConfig.headers['prod'] = "dy_cjyx";
                return reqConfig;
              } else {
                // TODO: token不存在后续处理………………
                LzMsg.error('登录状态失效，已重新加载');
              }
            }
          },
          onError: (error) => {
            return Promise.reject(error);
          }
        },
        response: {
          onConfig: ({ data, ...response }) => {
            if (response.headers['content-type'].indexOf('excel') > -1) {
              // 下载excel
              return {
                data: {
                  file: data,
                  suffix: '.xlsx'
                },
                ...response
              };
            }
            // 根据服务端返回的resp_code走进不同的请求处理分支
            const { resp_code, resp_msg, success, ...payload } = data;
            if (resp_code === 0) {
              // 请求成功，执行正常逻辑
              return {
                data: payload,
                ...response
              };
            } else {
              // 服务端返回异常，走入异常逻辑
              LzMsg.error(data.resp_msg, '');
              return Promise.reject({
                code: resp_code,
                message: resp_msg
              });
            }
          },
          onError: (error) => {
            // 请求异常处理
            if (error && error.response && error.response.data) {
              // 接收到返回数据
              const err = error.response.data;
              if (err.status === 500 && err.message.indexOf('无效的认证信息')) {
                // from参数 告诉登录组件结束登录之后需要后退回页面
                LzMsg.error('登录状态失效，已重新加载');
                // if (isInIcestark()) {
                //   setTimeout(() => {
                //     appHistory.replace('/login');
                //   }, 1000);
                // }
                return Promise.reject({
                  message: '登录状态失效，已重新加载'
                });
              } else {
                // return Promise.reject(error.response.data);
                LzMsg.error(error.response.data.resp_msg, '');
                return Promise.reject({
                  ...error.response.data,
                  message: error.response.data.resp_msg
                });
              }
            } else {
              // 网络请求失败走入异常逻辑
              // TODO: 异常的逻辑并没有被捕获
              LzMsg.error(error, '');
              return Promise.reject(error);
            }
          }
        }
      }
    }
  ]
};

// 封装方法
/**
 * 创建API服务工厂函数
 * @param {Object} apis - API配置对象
 * @returns {Object} 返回包含所有API方法的服务对象
 */
const factory = (apis) => {
  // 深拷贝apis配置，确保原始配置不被修改
  const service = JSON.parse(JSON.stringify(apis)); // hjy修改 原为【const service = {}】

  // 遍历模块的api列表，为每个api在模块的service中添加一个执行方法
  for (const api of Object.keys(apis)) {

    service[api] = (data = {}) => {

      // 获取请求的相关设置，默认是post请求，路径中无参数，非下载方法
      const { url, method = 'POST', hasPathParams = false, isDownload = false } = apis[api]

      let requestUrl = url

      // 如果请求路径url中含有参数，则从请求的data数据中的对应参数值替换url中的变量
      if (hasPathParams) {
        for (const key of Object.keys(data)) {
          requestUrl = requestUrl.replace(`{${key}}`, data[key])
        }
      }
      // 如果是下载则执行如下简单逻辑：
      // 把参数组织成query string方式，
      // 并拼接到请求地址，
      // 使用window.open方法打开
      if (isDownload) {
        // 和其他方法一样统一返回一个promise，方便通用处理
        return new Promise((resolve) => {
          window.open(`${requestUrl}?${Qs.stringify(data)}`);
          // 注意：此处执行resolve并不代表下载成功
          resolve(new Error('下载失败，请重试'));//hjy修改 原为 【resolve()】
        })
      } else {
        // 组织请求参数
        const req = {
          data: '' || {},//hjy添加
          params: {},//hjy添加
          url: requestUrl,
          method: method.toUpperCase(),
        };
        if (requestUrl === '/login') {
          // 登录接口使用，application/x-www-form-urlencoded 这种方式需要对body格式进行转化
          req.data = Qs.stringify(data)
        } else if (['GET', 'get', 'Get'].indexOf(method) > -1) {
          // if (requestUrl.indexOf('jdMockLogin') > -1) {
          //   req.url = requestUrl + data.shopId
          // } else {
          // get方法将参数写入params中
          req.params = data;
          // }
        } else {
          // 其他方法（post）参数写入data中
          req.data = data;
        }

        // 实时判断是否已登录，带有认证信息，并且需要排除login接口(login接口是去获取token的，不需要进行判断)
        return req.url.indexOf('/auth/login') === -1
          ?
          checkTokenExist(req.url).then(() => {
            request(req)
          })
          : request(req);
      }
    }
  }

  return service;
}

/**
 * 网路请求函数封装 -hjy添加
 * @param {string} api 接口地址
 * @param {object} argument 参数对象
 * @param {boolean} showLog 是否在控制台上打印获取到的数据
 */
const Servlets = async (api: string, argument: object = {}, showLog: boolean = false): Promise<object> => {

  let { url, method, hasPathParams } = allApis[api];

  // 判断当前环境是否为线上测试环境 - 【临时处理，项目上线后 请删除】
  if (window.location.host === '192.168.1.95' && !url.split('/').includes('api')) url = `/api${url}`;

  // 路由中存在参数时需特殊处理
  if (hasPathParams) for (const key of Object.keys(argument)) url = url.replace(`{${key}}`, argument[key]);

  // const token = '38969820-24ea-4bde-92c0-4d39146cada4';
  const token = sessionStorage.getItem('LZ_SSO_TOKEN');

  let RequestConfig = {
    url,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization': token,
      "prod": "dy_cjyx"
    },
    method: method.toLowerCase(),
    params: method.toLowerCase() === 'get' ? argument : {}, //get请求时使用
    data: argument,//post、 put、delete 请求时使用
    timeout: 20000,
    withCredentials: false, // 是否跨越请求数据
    // responseType: 'json', // 默认responseType为json，可注释
    withFullResponse: false,
  }

  const result = await request(RequestConfig);

  // 接口异常时给出提示
  // if (!result.success) LzMsg.error(result.resp_msg);

  // 是否在控制中显示log
  if (showLog) {
    let currentPageName = store.get('newSetBreadcrumb').map(res => { return res.name }).join('/');

    console.log(
      "%c" + `\n函数名:${api}\n\nAPI地址:${url}\n\n调用API页面:${currentPageName}\n`, "color: " + "#46bc15", `
      result.resp_code==>${result.resp_code}
      result.resp_msg==>${result.resp_msg}
      result.success==>${result.success}
      result.data==>\n`, result.data);
  }

  return result;
}


const createApiService = () => {
  const service = {};

  // 遍历所有API配置，为每个API创建一个方法
  for (const apiName in allApis) {
    if (Object.prototype.hasOwnProperty.call(allApis, apiName)) {
      service[apiName] = (argument: object = {}, showLog: boolean = false) => {
        return Servlets(apiName, argument, showLog);
      };
    }
  }

  return service;
};
// 执行函数创建 CanvasService 对象
const CanvasService = createApiService();

// 生成service
const Service = factory(Apis);
const CommonService = factory(commonApis);
// const CanvasService = factory(CanvasApis);


// 导出各个模块的service，
// 可以如此应用:
//  import { AccountService } from '@/service';
//  AccountService.login()
export {
  requestConfig,
  Service,
  CommonService,
  Servlets,//-hjy添加
  CanvasService
}

// 整体导出各个模块的service，
// 可以如此应用:
//  import Service from '@/service';
//  Service.Account.login()
export default Service;
